import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteCustomSurveyTemplate } from '../../api/customSurveyTemplates';
import { customSurveyTemplateKeys } from '../queries/queryKeys';

export const useDeleteCustomSurveyTemplateMutation = (options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteCustomSurveyTemplate(id),
    onSuccess: (_, id) => {
      // Invalidate the specific template and all lists
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.lists() });
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
};
